import React, { useEffect } from 'react';
import Button from '../../components/Button';
import TinselHeader from '../../components/TinselHeader/TinselHeader';
import snowflakeIcon1 from '../../assets/images/icons/snowflake1.webp';
import snowflakeIcon2 from '../../assets/images/icons/snowflake2.webp';
import { subscribeToChannel, shareApp, triggerHaptic } from '../../utils/telegramActions';
import { useUIText, useAppConstants } from '../../hooks/useConfig';
import { useAnalytics } from '../../hooks/useAnalytics';
import { Typo } from '../../utils/typo';
import './Result.scss';

function Result() {
    const UI_TEXT = useUIText();
    const APP_CONFIG = useAppConstants();
    const { trackEvent } = useAnalytics();

    useEffect(() => {
        trackEvent('view_result');
    }, [trackEvent]);

    const handleSubscribe = () => {
        triggerHaptic('medium');
        trackEvent('click_subscribe');
        subscribeToChannel(APP_CONFIG.TELEGRAM?.CHANNEL_URL);
    };

    const handleShare = () => {
        triggerHaptic('medium');
        trackEvent('click_share');
        shareApp(
            APP_CONFIG.TELEGRAM?.SHARE_URL,
            APP_CONFIG.TELEGRAM?.SHARE_TEXT,
            APP_CONFIG.TELEGRAM?.BOT_USERNAME
        );
    };

    return (
        <div className="result-container">
            <TinselHeader />
            <img src={snowflakeIcon1} alt="Snowflake" className="snowflake-icon top-left" />
            <img src={snowflakeIcon2} alt="Snowflake" className="snowflake-icon bottom-right" />
            <div className="result-content">
                <div className="result-main-text">
                    <div className="text-line">
                        <Typo>{UI_TEXT.RESULT?.TITLE_LINE_1}</Typo>
                    </div>
                    <div className="text-line">
                        <Typo>{UI_TEXT.RESULT?.TITLE_LINE_2}</Typo>
                    </div>
                </div>
                <div className="result-description">
                    <Typo>{UI_TEXT.RESULT?.DESCRIPTION}</Typo>
                </div>
            </div>
            <div className="result-footer">
                <Button
                    className="subscribe-btn"
                    active={true}
                    onClick={handleSubscribe}
                >
                    {UI_TEXT.RESULT?.BUTTON_SUBSCRIBE}
                </Button>
                <Button className="share-btn" onClick={handleShare}>
                    {UI_TEXT.RESULT?.BUTTON_SHARE}
                </Button>
            </div>
        </div>
    );
}

export default Result;
